import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { CONFIG_DRAWER_TAB_ACTIVE_PATH, CONFIG_DRAWER_TAB_LOADED_PATH, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_EXPANDED, LAYOUT_DRAWER_TABS_SEARCH_PANELS_FIND_EXPANDED, TOGGLE_TYPE_CLOSE, TOGGLE_TYPE_OPEN, getExpandedConfigPathFromPanelID, togglePanel } from 'api/actions'
import * as Model from 'api/model'
import SearchPanelDirections from 'drawer/tabs/search/panels/SearchPanelDirections'
import SearchPanelFind from 'drawer/tabs/search/panels/SearchPanelFind'

const styles = theme => ({
  root: {
    width: '100%',
    overflow: 'hidden',
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 10,
    paddingBottom: 10
  }
})

class SearchPanels extends React.Component {
  constructor () {
    super()
    const myEl = document.getElementById('pozi-drawer-tabs-button-search')
    myEl.addEventListener('click', () => { Model.set('app.drawer.activetabid', 'search') }, false)

    this.pure = {}
    this.pure.toggleExpansionPanelSearch = this.toggleExpansionPanel(LAYOUT_DRAWER_TABS_SEARCH_PANELS_FIND_EXPANDED).bind(this)
    this.pure.toggleExpansionPanelDirections = this.toggleExpansionPanel(LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_EXPANDED).bind(this)
  }

  closeAllPanelsExceptPanelId (panelId) {
    const { togglePanel } = this.props
    if (panelId !== LAYOUT_DRAWER_TABS_SEARCH_PANELS_FIND_EXPANDED) {
      togglePanel(LAYOUT_DRAWER_TABS_SEARCH_PANELS_FIND_EXPANDED, TOGGLE_TYPE_CLOSE)
    }
    if (panelId !== LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_EXPANDED) {
      togglePanel(LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_EXPANDED, TOGGLE_TYPE_CLOSE)
    }
  }

  toggleExpansionPanel (panelId) {
    return function () {
      const { togglePanel } = this.props
      this.closeAllPanelsExceptPanelId(panelId)
      togglePanel(panelId) // Toggle
    }
  }

  render () {
    const { classes, bSearchTabLoaded, bSearchTabOpen, togglePanel } = this.props

    // Optimisation to avoid loading panels if not on search tab.
    // Note this is set indirectly by Model.set('app.drawer.activetabid', 'search')
    if (!bSearchTabLoaded || !bSearchTabOpen) {
      return null
    }

    // The following section of code should not be in the render function
    const panelId = Model.getState('panel')
    const expandedPanel = getExpandedConfigPathFromPanelID(panelId)
    if (expandedPanel !== '') {
      // Hack to make this run without React givng a warning about a component
      // being updated from inside the function body of a different component
      const self = this
      window.setTimeout(function () {
        self.closeAllPanelsExceptPanelId(panelId)
        togglePanel(expandedPanel, TOGGLE_TYPE_OPEN)
      }, 0)
    }

    return (
      <div className={classes.root}>
        <SearchPanelFind toggleExpansionPanel={this.pure.toggleExpansionPanelSearch}/>
        <SearchPanelDirections toggleExpansionPanel={this.pure.toggleExpansionPanelDirections}/>
      </div>
    )
  }
}

SearchPanels.propTypes = {
  classes: PropTypes.object.isRequired,
  togglePanel: PropTypes.func.isRequired,
  bSearchTabLoaded: PropTypes.bool.isRequired,
  bSearchTabOpen: PropTypes.bool.isRequired
}

function mapStateToProps (state, ownProps) {
  const searchTabLoadedPath = CONFIG_DRAWER_TAB_LOADED_PATH + '.search'
  const bSearchTabLoaded = get(state.config, searchTabLoadedPath, false)
  const activeTabId = get(state, 'config.' + CONFIG_DRAWER_TAB_ACTIVE_PATH, '')
  const bSearchTabOpen = activeTabId === 'search'
  return {
    bSearchTabLoaded,
    bSearchTabOpen
  }
}

const mapDispatchToProps = dispatch => {
  return {
    togglePanel: (type, toggleType) => {
      dispatch(togglePanel(type, toggleType))
    }
  }
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SearchPanels)
  )
)
